import * as yup from 'yup'
import { legalPersonsInputs } from '../../../constants/legalPersonsPage'

const requireStr = yup.string().required("Це обов'язкове поле")

export const schema: yup.SchemaOf<legalPersonsInputs> = yup.object().shape({
	name: requireStr,
	code: requireStr,
	address: requireStr,
	iban: requireStr,
	bank: requireStr,
	directorName: requireStr,
	directorLastname: requireStr,
	directorSurname: yup.string().nullable(),
	directorBirthdate: yup.date().max(new Date(), 'Некоректна дата').nullable().transform((value, originalValue) => (originalValue === '' ? null : value)),
	directorEmail: requireStr.email('Некоректна електронна адреса'),
	directorPhone: requireStr.matches(/^(\d{12})$/, 'Номер повинен бути у форматі 380961111111'),
	status: yup.boolean().nullable(),
	overdraftAmount: yup.number().nullable(),
	lowerLimit: yup.number().nullable(),
	discountPerLiter: yup.number().nullable(),
})

export const reconciliationSchema = yup.object().shape({
	dateFrom: yup.date().required("Дата з є обов'язковою").typeError("Дата з є обов'язковою"),
	dateTo: yup.date().required("Дата до є обов'язковою").min(yup.ref('dateFrom'), 'Дата до має бути пізнішою за дату з').typeError("Дата до є обов'язковою"),
})
